<script lang="ts" setup>
import LightArrowIcon from "@/components/icon/LightArrowIcon.vue";
import { computed, ref } from "vue";
import { useAllVisibility } from "@/use/common";
import { Visibility } from "@/types/entity";

const props = defineProps<{
  visibility: Visibility;
}>();
const emit = defineEmits<{
  (e: "update:visibility", value: Visibility): void;
}>();

const VISIBILITIES = useAllVisibility();
const visibilityText = computed(() => {
  return VISIBILITIES.find((v) => v.value === props.visibility)?.text;
});
const show = ref(false);
</script>
<template>
  <button
    class="btn btn-xs rounded-2xl w-fit text-base-content"
    @click="show = true"
  >
    {{ visibilityText }}
    <light-arrow-icon class="w-3 h-3 -rotate-90" />
  </button>
  <VisibilitySelectModal
    v-model:show="show"
    :visibility="visibility"
    @update:visibility="emit('update:visibility', $event)"
  />
</template>
